<template>
  <div>
    <h4 class="card-title mb-3">
      Takaful Points Earned Report
    </h4>

    <div class="row">
      <div class="col-6">
        <label><b>Date From</b></label>
        <input type="date" v-model="date_from" class="form-control" />
      </div>
      <div class="col-6">
        <label><b>Date To</b></label>
        <input type="date" v-model="date_to" class="form-control" />
      </div>
    </div>

    <br />

    <div class="text-right">
      <button class="btn btn-rounded btn-primary mr-2" style="width: 150px;" @click="handleFilter">
        Filter
      </button>
      <button class="btn btn-rounded btn-primary" style="width: 150px;" @click="handleReset">
        Reset
      </button>
    </div>

    <div class="mt-4">
      <CustomersEarned :headers="headerData" :customers="customerData"
        :id="'tbl_cust_earned'" :tableWidth="customerButtons[0].status ? '450%' : '400%'"  />

    </div>

    <Loading
      :active.sync="pageLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></Loading>

  </div>
</template>

<script>
import CustomersEarned from './CustomersEarned.vue';
import { getEarned, getRedeemed } from '../../../../../services/SummaryReportServices';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: 'customer-report-summary',

  components: { CustomersEarned, Loading },

  props: {
    customerButtons: {
      type: Array,
      required: true
    },

    currentActiveTab: {
      type: Number,
      required: SVGComponentTransferFunctionElement
    }
  },

  data() {
    return {
      points: [],

      dataTable: null,

      earnedTable: null,
      redeemedTable: null,

      headerData: [],
      customerData: [],

      extraRequest: null,
      date_from: '',
      date_to: '',

      pageLoading: false,
    }
  },

  watch: {
    customerButtons: {
      async handler() {
        this.resetDate();
        await this.handleFilter();
      },
      deep: true
    },

    async currentActiveTab() {
      if (this.currentActiveTab === 2) {
        await this.handleFilter();
      }
    }
  },

  methods: {
    async fetchEarned() {
      try {
        const response = await getEarned(this.extraRequest);

        if (response.data.success) {
          this.headerData = response.data.data.table_headers;
          this.customerData = response.data.data.table_data;
        }

      } catch (e) {
        console.error(e);
      }
    },

    async fetchRedeemed() {

      try {
        const response = await getRedeemed(this.extraRequest);

        if (response.data.success) {
          this.headerData = response.data.data.table_headers;
          this.customerData = response.data.data.table_data;
        }

      } catch (e) {
        console.error(e)
      }

    },

    buildExtraRequest() {
      const filters = [];
      if (this.date_from && this.date_to) filters.push(`date_from=${this.date_from}&date_to=${this.date_to}`);
      return filters.length ? `?${filters.join('&')}` : null;
    },

    async handleFilter() {
      this.pageLoading = true;

      if(this.dataTable) {
        this.dataTable.destroy();
      }

      this.extraRequest = this.buildExtraRequest();

      if (this.customerButtons[0].status) {
        await this.fetchEarned();
      }
      if (this.customerButtons[1].status) {
        await this.fetchRedeemed();
      }

      this.$nextTick(() => {
        this.dataTable = this.setDatatable2('tbl_cust_earned');
      });

      this.pageLoading = false;
    },

    resetDate() {
      this.date_from = this.date_to = '';
      this.extraRequest = null;
    },

    async handleReset() {
      this.resetDate();
      await this.handleFilter();
    },

    setDatatable2(id) {
      return $(`#${id}`).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5"
          },
        ]
      });
    },
  },

  async mounted() {
  }
}
</script>
